// @flow

import {
  BRANCH,
} from 'hfty-model-orders'

export default {
  [BRANCH]: {},
}
